export default "__VITE_ASSET__Bu3d6vQh__"